module.exports = "<sq-license-management class=\"flexColumnContainer flexFillOverflow overflowAuto\"></sq-license-management>\n";